import { useContext } from 'react';
import { assetsCdnUrl } from '~/constants/environment';
import MenuOptionLabel from '~/constants/srp/MenuOptionLabel';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import FacetDataContext, {
  useFacetData
} from '~/context/common/FacetDataContext';
import SearchContext from '~/context/srp/SearchContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';

const generateId = (name: string) => name.replace(/\s/g, '').toLowerCase();

type LabelProps = {
  bodyType: string;
  displayName: string;
};

const BodyTypeLabel = ({ bodyType, displayName }: LabelProps) => (
  <div className="flex items-center justify-between">
    <span>{displayName}</span>
    <img
      src={`${assetsCdnUrl}/search-assets/body-types/${bodyType.toLowerCase()}.png?width=150`}
      className="h-44"
      alt={bodyType}
    />
  </div>
);

export default function BodyType() {
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const { expandOnOpen } = useContext(SearchContext);
  const { showInventoryCounts } = useContext(FacetDataContext);
  const facetData = useFacetData();
  const expandSection = expandOnOpen === MenuOptionLabel.BodyType;

  return (
    <FilterDrawer
      testId="facet-body-style"
      facetContent={facetData.bodyStyles?.buckets}
      facetName="Body Type"
      defaultExpanded={expandSection}
    >
      <div className="grid gap-lg">
        {facetData.bodyStyles?.buckets.map(({ count, displayName, key }) => (
          <Checkbox
            checked={Boolean(appliedFilters.bodyStyles?.includes(key))}
            className="mb-[-0.125em] grid grid-cols-[auto_1fr] items-center"
            facet="bodyStyle"
            filter={displayName}
            id={`body-type-${generateId(displayName)}`}
            key={displayName}
            label={
              <BodyTypeLabel
                bodyType={displayName}
                displayName={
                  showInventoryCounts
                    ? `${displayName} (${count.toLocaleString()})`
                    : displayName
                }
              />
            }
            onChange={() =>
              updateListFilter({
                filterKey: 'bodyStyles',
                value: key
              })
            }
          />
        ))}
      </div>
    </FilterDrawer>
  );
}
